import { League } from '@/types/api.generated';
import { create } from 'zustand';

export const lobbyId = 'lobby';

export type TileType = 'lobby' | League;

export interface LobbySectionSelection {
    selectedTile: TileType;
    eventId: string | undefined;
    actions: {
        getSelectedTile: () => string;
        setSelectedTile: (league: TileType) => void;
    };
}

export const useLobbySectionSelection = create<LobbySectionSelection>()((set, get) => ({
    selectedTile: lobbyId,
    eventId: undefined,
    actions: {
        setSelectedTile: (tile: TileType) => {
            set({ selectedTile: tile });
        },
        getSelectedTile: () => {
            return get().selectedTile;
        },
    },
}));
